const isEqual = (a, b) => {
  if (a === b) {
    return true;
  }
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
    return false;
  }
  if (Array.isArray(a) !== Array.isArray(b)) {
    return false;
  }
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every((key) => Object.hasOwn(b, key) && isEqual(a[key], b[key]));
};

const isSameStep = (a, b) =>
  a.data?.label === b.data?.label &&
  a.data?.custom?.key === b.data?.custom?.key &&
  isEqual(a.data?.custom?.values, b.data?.custom?.values) &&
  isEqual(a.data?.custom?.labels, b.data?.custom?.labels);

const stepName = (node) => {
  const name = node.data?.label ?? node.data?.custom?.key ?? node.id;
  const element = node.data?.custom?.labels?.id;
  return element ? `${name} '${element}'` : name;
};

const BRANCHES = {
  conditional: { conditionMatched: 'if matched', conditionNotMatched: 'if not matched' },
  abSplit: { conditionMatched: 'left branch', conditionNotMatched: 'right branch' },
};

const connectionKey = (edge) => JSON.stringify([edge.source, edge.sourceHandle || null, edge.target]);

export const diffFlows = (currentFlow, proposedFlow) => {
  const currentNodes = new Map(currentFlow.nodes.map((node) => [node.id, node]));
  const proposedNodes = new Map(proposedFlow.nodes.map((node) => [node.id, node]));
  const allNodes = new Map([...currentNodes, ...proposedNodes]);

  const added = proposedFlow.nodes.filter((node) => !currentNodes.has(node.id));
  const removed = currentFlow.nodes.filter((node) => !proposedNodes.has(node.id));
  const changed = proposedFlow.nodes.filter(
    (node) => currentNodes.has(node.id) && !isSameStep(currentNodes.get(node.id), node)
  );

  const currentConnections = new Set(currentFlow.edges.map(connectionKey));
  const proposedConnections = new Set(proposedFlow.edges.map(connectionKey));
  const connected = proposedFlow.edges.filter((edge) => !currentConnections.has(connectionKey(edge)));
  const disconnected = currentFlow.edges.filter((edge) => !proposedConnections.has(connectionKey(edge)));
  const connection = (edge) => {
    const source = allNodes.get(edge.source);
    const branch = BRANCHES[source.type]?.[edge.sourceHandle];
    return `${stepName(source)}${branch ? ` (${branch})` : ''} to ${stepName(allNodes.get(edge.target))}`;
  };

  const nodeStatus = new Map([
    ...added.map((node) => [node.id, 'added']),
    ...removed.map((node) => [node.id, 'removed']),
    ...changed.map((node) => [node.id, 'changed']),
  ]);

  const differences = [
    ...added.map((node) => ({ kind: 'added', text: `Added: ${stepName(node)}` })),
    ...removed.map((node) => ({ kind: 'removed', text: `Removed: ${stepName(node)}` })),
    ...changed.map((node) => ({ kind: 'changed', text: `Changed: ${stepName(node)}` })),
    ...connected.map((edge) => ({ kind: 'added', text: `Connected: ${connection(edge)}` })),
    ...disconnected.map((edge) => ({ kind: 'removed', text: `Disconnected: ${connection(edge)}` })),
  ];

  return { nodeStatus, differences };
};
